import React, { useState } from 'react';
import {
    Box,
    Button,
    FormControl,
    FormLabel,
    Input,
    VStack,
    Heading,
    Flex,
    Select,
    useBreakpointValue,
    Image,
} from '@chakra-ui/react';

const initialFormData = {
    name: "JHT",
    status: "active",
    notes: "Initial customer setup.",
    config: {
        operationType: [
            // Only showing the structure for one operation type for brevity
        ],
        logoURL: "https://johnsonfitness.tienda/media/athlete2/websites/2/logo-johnsonfitness.jpg",
        backEndPassword: "password2!",
        backEndUser: "jht@email.com",
        EPCorDbType: "DB",
        customerPrefix: "4A4A",
        darkLogoURL: "https://moviltrack.com/temp/logo-johnsonfitnessdark.png",
    },
    createdAt: "1700779348201", // Simplified for the example
};

/* const OperationTypeForm = ({ operation, onChange }) => {
    // Simplified rendering of operation types
    return (
        <VStack align="start" spacing={4}>
            <FormControl>
                <FormLabel>Name</FormLabel>
                <Input value={operation.name} onChange={e => onChange({ ...operation, name: e.target.value })} />
            </FormControl>
            
        </VStack>
    );
}; */



const CustomerForm = () => {
    const [formData, setFormData] = useState(initialFormData);
    const formControlSize = useBreakpointValue({ base: 'sm', md: 'md' });

    /*    const handleOperationTypeChange = (index, newOperation) => {
           const newOperations = [...formData.config.operationType];
           newOperations[index] = newOperation;
           setFormData({ ...formData, config: { ...formData.config, operationType: newOperations } });
       }; */

    return (
        <Box p={5}>
            <VStack spacing={5} align="stretch">
                <Heading size="lg">Edit Configuration</Heading>
                <FormControl id="name">
                    {/* Previous form controls */}
                </FormControl>
                {/* Additional form controls for the new fields */}
                <FormControl id="logoURL">
                    <FormLabel>Logo URL</FormLabel>
                    <Input size={formControlSize} value={formData.config.logoURL} onChange={(e) => setFormData({ ...formData, config: { ...formData.config, logoURL: e.target.value } })} />
                    <Box mt="2">
                        <Image src={formData.config.logoURL} alt="Logo" boxSize="100px" objectFit="contain" />
                    </Box>
                </FormControl>
                <FormControl id="darkLogoURL">
                    <FormLabel>Dark Logo URL</FormLabel>
                    <Input size={formControlSize} value={formData.config.darkLogoURL} onChange={(e) => setFormData({ ...formData, config: { ...formData.config, darkLogoURL: e.target.value } })} />
                    <Box mt="2">
                        <Image src={formData.config.darkLogoURL} alt="Dark Logo" boxSize="100px" objectFit="contain" />
                    </Box>
                </FormControl>
                <FormControl id="backEndUser">
                    <FormLabel>Backend User</FormLabel>
                    <Input size={formControlSize} value={formData.config.backEndUser} onChange={(e) => setFormData({ ...formData, config: { ...formData.config, backEndUser: e.target.value } })} />
                </FormControl>
                <FormControl id="backEndPassword">
                    <FormLabel>Backend Password</FormLabel>
                    <Input size={formControlSize} value={formData.config.backEndPassword} onChange={(e) => setFormData({ ...formData, config: { ...formData.config, backEndPassword: e.target.value } })} type="password" />
                </FormControl>
                <FormControl id="EPCorDbType">
                    <FormLabel>Customer Filter by EPC or DB Type</FormLabel>
                    <Select size={formControlSize} value={formData.config.EPCorDbType} onChange={(e) => setFormData({ ...formData, config: { ...formData.config, EPCorDbType: e.target.value } })}>
                        <option value="DB">DB</option>
                        <option value="EPC">EPC</option>
                    </Select>
                </FormControl>
                <FormControl id="customerPrefix">
                    <FormLabel>Customer Prefix</FormLabel>
                    <Input size={formControlSize} value={formData.config.customerPrefix} onChange={(e) => setFormData({ ...formData, config: { ...formData.config, customerPrefix: e.target.value } })} />
                </FormControl>
                {/* Continue with the rest of the form */}
                <Flex justify="flex-end">
                    <Button colorScheme="blue">Save Changes</Button>
                </Flex>
            </VStack>
        </Box>
    );
};

export default CustomerForm;
